module.exports = __webpack_public_path__ + "images/3.1782880901430.jpg";